import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { NbaTargetTypes } from '~/app/tracking/feld-m-types';

export const local: PartialCarConfiguration = {
	hasJetStream: true,

	showCaESummaryText: true,
	engineCardKeyfacts: ['acceleration', 'maxPower', 'electricRanges'],
	extendedTechnicalAttributes: {
		wltp: ['fuel-supply', 'gasoline-equivalent'],
	},
	useStaticPriceDateRemark: true,
	showEECLabel: true,
	showEECLabelEngine: false,
	wltpInfo: {
		url: {
			url: 'https://mediaservice.audi.com/media/b2c/v6-common/img-HEAD.zip/v6/eec-ch-2024/:LANG/eec-label-b.png',
			pathParams: {},
			queryParams: [],
		},
	},
	financeDomain: 'AUDI.CC.CH',
	enablePriceDisclaimer: true,
	financingDisclaimer: ['globalDisclaimer'],
	nextBestActions: [
		{
			description: 'Offertanfrage für Ihren Audi senden',
			labelText: 'Offertanfrage',
			target: '_blank',
			icon: '',
			trackingName: 'contact',
			url: 'https://www.audi.ch/ch/web/de/neuwagen/layer_landing_pages/offertanfrage-konfigurator/{{hyphenCarlineId}}.html',
		},
		{
			description: 'Ladestationrechner aufrufen',
			labelText: 'Ladestationrechner',
			target: '_blank',

			icon: 'wallbox',
			trackingName: NbaTargetTypes.BuyWallbox,
			url: 'https://em.offerten-rechner.ch/where-to-install-charger?partnerid=audi',
		},
	],
	summaryFooterCta: {
		description: 'Probefahrt vereinbaren',
		labelText: 'Probefahrt vereinbaren',
		target: '_blank',

		icon: 'test-drive',
		trackingName: 'testdrive',
		url: 'https://www.audi.ch/ch/web/de/neuwagen/layer_landing_pages/probefahrt-konfigurator/{{hyphenCarlineId}}.html',
	},
	showEfficiencyClass: true,
};
